import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {Task, TaskGroupService} from '../../../../../core/services/taskGroup.service';

export interface UserTaskAssignment {
  taskId: number;
  eventId?: number | null;
  elearningId?: number | null;
  learningPathsId?: number | null;
  learnPathsId?: number | null;
}

export interface AddTaskModalData {
  tasks: UserTaskAssignment[];
}

interface SelectableTaskGroup {
  id: number;
  title: string;
  tasks: Task[];
  selectedTasks: Task[];
}

@Component({
  selector: 'add-task-modal',
  templateUrl: './add-task-modal.component.html',
  styleUrls: ['./add-task-modal.component.scss'],
  standalone: false
})
export class AddTaskModalComponent implements OnInit {
  taskGroups: SelectableTaskGroup[] = [];
  loading = true;
  loadFailed = false;
  assignedTaskIds = new Set<number>();

  constructor(public dialogRef: MatDialogRef<AddTaskModalComponent, Task[]>,
              @Inject(MAT_DIALOG_DATA) public data: AddTaskModalData,
              private taskService: TaskGroupService) {}

  ngOnInit() {
    this.assignedTaskIds = new Set(this.data.tasks.map(task => task.taskId));
    this.taskService.getTask().subscribe({
      next: (tasks) => {
        const groups = new Map<number, SelectableTaskGroup>();
        for (const task of tasks) {
          if (!groups.has(task.taskGroupId)) {
            groups.set(task.taskGroupId, {
              id: task.taskGroupId, title: task.taskGroup?.title || '—', tasks: [], selectedTasks: []
            });
          }
          const group = groups.get(task.taskGroupId);
          group.tasks.push(task);
          if (this.assignedTaskIds.has(task.id)) {
            group.selectedTasks.push(task);
          }
        }
        this.taskGroups = Array.from(groups.values());
        this.loading = false;
      },
      error: () => {
        this.loadFailed = true;
        this.loading = false;
      }
    });
  }

  selectGroupTasks(group: SelectableTaskGroup, tasks: Task[]) {
    const selectedIds = new Set(tasks.map(task => task.id));
    group.selectedTasks = group.tasks.filter(task => this.assignedTaskIds.has(task.id) || selectedIds.has(task.id));
  }

  isGroupDisabled(group: SelectableTaskGroup) {
    return group.tasks.every(task => this.assignedTaskIds.has(task.id));
  }

  save() {
    this.dialogRef.close(this.taskGroups.flatMap(group => group.selectedTasks)
      .filter(task => !this.assignedTaskIds.has(task.id)));
  }
}
